import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Template from "../layout/Template";
import Login from "../pages/auth/login";
import Home from "../pages/home";
import Faq from "../pages/faq";
import Contact from "../pages/contacts";
import Profile from "../pages/profile/informations";
import Address from "../pages/profile/addresses";
import Cart from "../pages/carts";
import CartShipping from "../pages/carts/shippings";
import CartCheckout from "../pages/carts/checkout";
import Orders from "../pages/profile/orders";
import Transactions from "../pages/profile/transactions";
import ConplateInformation from "../pages/profile/informations/complate_information";
import Menu from "../pages/menu";

const Routes = ({ user }) => {
  const PrivateRoutePanel = ({ component: Component, ...rest }) => {
    const renderPage = () => {
      return (
        <Template
          header={rest.header}
          headerWeb={rest.headerWeb}
          headerMob={rest.headerMob}
          footer={rest.footer}
          footerMob={rest.footerMob}
          footerWeb={rest.footerWeb}
        >
          <Route {...rest} render={(props) => <Component {...props} />} />
        </Template>
      );
    };

    if (
      rest?.path !== "/profile/information" &&
      user?.token &&
      !user?.data?.full_name
    ) {
      return <Redirect to="/profile/information" />;
    }

    if (
      rest?.path === "/profile/information" &&
      user?.token &&
      user?.data?.full_name
    ) {
      return <Redirect to="/" />;
    }

    if (rest.auth === false) {
      return user?.token ? <Redirect to="/" /> : renderPage();
    } else if (rest.auth) {
      if (user?.token) {
        return renderPage();
      } else {
        return <Redirect to="/login" />;
      }
    } else {
      return renderPage();
    }
  };
  const PublicRoutePanel = ({ component: Component, ...rest }) => {
    const renderPage = () => {
      return (
        <Template
          header={rest.header}
          showIcon={false}
          headerWeb={rest.headerWeb}
          headerMob={rest.headerMob}
          footer={rest.footer}
          footerMob={rest.footerMob}
          footerWeb={rest.footerWeb}
        >
          <Route {...rest} render={(props) => <Component {...props} />} />
        </Template>
      );
    };
    return renderPage()
  };

  return (
    <Router>
      <Switch>
        <PrivateRoutePanel component={Home} path="/" exact />
        <PublicRoutePanel component={Menu} path="/menu" exact />
        <PrivateRoutePanel
          component={Login}
          path="/login"
          header={false}
          auth={false}
        />
        <PrivateRoutePanel
          component={Orders}
          path="/profile/orders"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "سفارشات",
            handleBack: "/",
          }}
          auth={true}
        />
        <PrivateRoutePanel
          component={Faq}
          path="/faq"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "قوانین و مقررات",
          }}
        />
        <PrivateRoutePanel
          component={Contact}
          path="/contact"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "ارتباط با ما",
          }}
        />
        <PrivateRoutePanel
          component={ConplateInformation}
          path="/profile/information"
          header={false}
          auth={true}
        />
        <PrivateRoutePanel
          component={Transactions}
          path="/profile/transactions"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "لیست پرداختی ها",
          }}
          auth={true}
        />
        <PrivateRoutePanel
          component={Address}
          path="/profile/addresses"
          header={false}
          auth={true}
        />
        <PrivateRoutePanel component={Profile} path="/profile" auth={true} />
        <PrivateRoutePanel
          component={CartCheckout}
          path="/carts/checkout"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "تایید و پرداخت",
          }}
          auth={true}
        />
        <PrivateRoutePanel
          component={CartShipping}
          path="/carts/shipping"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "نحوه ارسال",
          }}
          auth={true}
        />
        <PrivateRoutePanel
          component={Cart}
          path="/carts"
          headerMob={{
            headerType: "headerChild",
            headerTitle: "سبد خرید",
          }}
        />
      </Switch>
    </Router>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, false)(Routes);
